<template>
  <div :class="['alertBar', { opened }]">
    <div class="container">
      <div class="alertBar__message">
        {{ message }}
      </div>
      <div class="alertBar__actions">
        <BigButton
          v-if="action"
          secondary
          class="alertBar__action"
          @click="action"
        >
          {{ actionLabel }}
        </BigButton>
      </div>
    </div>
  </div>
</template>

<script>
import BigButton from '@/components/BigButton';

export default {
  name: 'AlertBar',

  components: { BigButton },

  props: {
    opened: { type: Boolean, required: false, default: false },
    message: { type: String, required: false, default: '' },
    actionLabel: { type: String, required: false, default: 'OK' },
    action: { type: Function, required: false, default: null },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
